import { useSelector } from "react-redux";
import "../App.css";
import SettingsView from "../components/SettingsView";
function Properties() {
  const user = useSelector((state: any) => state.user);

  const settingsContent = <SettingsView />;

  return (
    <div className="App">
      {user &&
        user.id &&
      
        settingsContent}
    </div>
  );
}

export default Properties;
